import { UIView } from "@uirouter/react";
import { ErrorBoundary } from "react-error-boundary";

import { PageTopBanner } from "app/components/PageTopBanner/PageTopBanner";
import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";

import { generateAutomationName } from "./helpers/helpers";

const BenchmarkTrackerRoot = () => {
    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <div
                data-automation={generateAutomationName("root", ["navigation", "wrapper"])}
                className="sw-layout-module-inner"
            >
                <div
                    className="u-flex-row u-flex-column"
                    style={{ flexGrow: 1, overflowX: "hidden", width: "100%" }}
                >
                    <PageTopBanner />
                    <UIView className="sw-layout-scrollable-element sw-layout-research disable-top-padding use-sticky-css-rendering fadeIn" />
                </div>
            </div>
        </ErrorBoundary>
    );
};

export default BenchmarkTrackerRoot;
